import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="var(--sds--ursa-icons--inner-shape-color, transparent)"
            fillRule="evenodd"
            d="M10 11.563a.7.7 0 0 1-.7-.7V8.285a.7.7 0 1 1 1.4 0v2.578a.7.7 0 0 1-.7.7"
            clipRule="evenodd"
        />
        <path
            fill="var(--sds--ursa-icons--inner-shape-color, transparent)"
            d="M9.267 13.31a.69.69 0 1 1 1.38 0 .69.69 0 0 1-1.38 0"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12.143 4.92c-.953-1.65-3.333-1.65-4.285 0l-4.54 7.864c-.906 1.57.227 3.533 2.04 3.533h9.284c1.813 0 2.947-1.963 2.04-3.533zM9.3 10.863a.7.7 0 1 0 1.4 0V8.285a.7.7 0 0 0-1.4 0zm.657 1.756a.69.69 0 1 0 0 1.381.69.69 0 0 0 0-1.38"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
